var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 17.7498L33.5 21.4998M33.5 21.4998L37.25 25.2498M33.5 21.4998L37.25 17.7498M33.5 21.4998L29.75 25.2498M12.25 15.2498L20.1167 7.38315C20.2915 7.20855 20.5141 7.08968 20.7564 7.04154C20.9988 6.9934 21.2499 7.01815 21.4782 7.11267C21.7065 7.20719 21.9016 7.36723 22.039 7.57259C22.1764 7.77795 22.2498 8.01941 22.25 8.26648V34.7331C22.2498 34.9802 22.1764 35.2217 22.039 35.427C21.9016 35.6324 21.7065 35.7924 21.4782 35.887C21.2499 35.9815 20.9988 36.0062 20.7564 35.9581C20.5141 35.9099 20.2915 35.7911 20.1167 35.6165L12.25 27.7498H8.51667C7.05001 27.7498 5.67667 26.9048 5.28667 25.4931C4.92919 24.1922 4.74867 22.849 4.75001 21.4998C4.75001 20.1165 4.93667 18.7781 5.28667 17.5065C5.67667 16.0931 7.05001 15.2498 8.51667 15.2498H12.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicMute);
export default __webpack_public_path__ + "static/media/music-mute.75255a490fedbec83f8072c5b2c5a8b4.svg";
export { ForwardRef as ReactComponent };